import logo from '../../Assets/Images/rklogo.png'
import React, { useLayoutEffect, useMemo, useState } from 'react'
import { motion } from 'framer-motion'
import { BsCheckCircleFill } from 'react-icons/bs'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FieldInput from '../../Components/FieldInput'
import Button from '../../Components/Button'
import API from '../../Common/API'
import { useHistory } from 'react-router-dom'
import { setAlert } from '../../Store/Theme/actions'
import { useTranslation } from 'react-i18next'
import FieldSelect from '../../Components/FieldSelect'
import { useDispatch } from 'react-redux'

const initialSignUpForm = {
    accountType: '',
    rkId: null,
    firstName: '',
    lastName: '',
    email: null,
    mobileNumber: null,
    // address: {
    //     addressLine1: '',
    //     addressLine2: '',
    //     state: '',
    //     city: '',
    //     pinCode: ''
    // },
    password: '',
    confirmPassword: '',
}

const accountTypes = [{ text: 'Buyer', value: 'buyer' }, { text: "Seller", value: 'seller' }]
const firmTypes = [{ text: 'Partnership Firm', value: 'partnershipFirm' }, { text: 'Sole Proprietorship', value: 'soleProprietorship' }, { text: 'Private Limited (PVT LTD)', value: 'privateLimited' }, { text: 'Public Limited (PLC)', value: 'publicLimited' }]
const SignUp = () => {

    const history = useHistory()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const { t } = useTranslation()
    const [createType, setCreateType] = useState()
    const [addressEdit, setAddressEdit] = useState(false)
    const [imageSrc, setImageSrc] = useState(null)
    const dispatch = useDispatch()

    const signupFormSchema = useMemo(() => createType === 'buyer' ? Yup.object().shape({
        accountType: Yup.string().required("Account Type is required"),
        rkId: Yup.string().nullable(),
        firstName: Yup.string().required('First Name is required'),
        lastName: Yup.string().nullable(),
        email: Yup.string().nullable(),
        mobileNumber: Yup.string().required("Mobile is required"),
        password: Yup.string().required("Password is required"),
        confirmPassword: Yup.string().required("Password is required"),
    }) : Yup.object().shape({
        accountType: Yup.string().required("Account Type is required"),
        rkId: Yup.string().nullable(),
        firstName: Yup.string().required('First Name is required'),
        lastName: Yup.string().nullable(),
        email: Yup.string().nullable(),
        mobileNumber: Yup.string().required("Mobile is required"),
        password: Yup.string().required("Password is required"),
        confirmPassword: Yup.string().required("Password is required"),
        firmDetails: Yup.object().shape({
            firmRegistrationType: Yup.string().required("Firm Registration is required"),
            bankDetails: Yup.object().shape({
                accountNo: Yup.string().required("Account Number is required"),
                accountName: Yup.string().required("Account Name is required"),
                ifscCode: Yup.string().required("IFSC Code is required"),
                bankName: Yup.string().required("Bank Name is required"),
                branchName: Yup.string().required("Branch Name is required")
            }),
            email: Yup.string().nullable(),
            mobileNumber: Yup.string().required("Mobile is required"),
            panCardNo: Yup.string().required("PAN Card is required"),
            accountName: Yup.string().required("Firm name is required"),
            accountAddress: Yup.object().shape({
                addressLine1: Yup.string().required("Address Line 1 is required"),
                addressLine2: Yup.string().nullable(),
                state: Yup.string().required("State is required"),
                landMark: Yup.string().nullable(),
                district: Yup.string().required("District is required"),
                city: Yup.string().required("City is required"),
                pinCode: Yup.string().required("Pincode is required")
            }),
            businessProof: Yup.string().nullable()
        })
    }), [createType])

    const signupForm = useFormik({
        initialValues: {
            accountType: '',
            rkId: null,
            firstName: '',
            lastName: '',
            email: null,
            mobileNumber: null,
            password: '',
            confirmPassword: '',
            firmDetails: createType === 'seller' ? {
                firmRegistrationType: '',
                bankDetails: {
                    accountNo: '',
                    accountName: '',
                    ifscCode: '',
                    branchName: '',
                    bankName: ''
                },
                panCardNo: '',
                accountName: '',
                mobileNumber: '',
                accountAddress: {
                    addressLine1: '',
                    addressLine2: '',
                    state: '',
                    district: '',
                    landMark: '',
                    city: '',
                    pinCode: ''
                },
                businessProof: ''
            } : undefined
        },
        validateOnMount: true,
        validationSchema: signupFormSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setSubmitDisabled(true);

            if (values.password !== values.confirmPassword) {
                signupForm.setErrors({ confirmPassword: 'Passwords do not match' });
                setSubmitDisabled(false);
                return;
            }

            try {
                if (createType === 'seller' && imageSrc) {
                    // await signupForm.setFieldValue("firmDetails.businessProof", imageSrc);
                    if (!imageSrc) {
                        dispatch(setAlert({ title: 'Error', subtitle: 'Please upload your business proof', active: true, type: 'error' }))
                        setSubmitDisabled(false);
                        return;
                    } else {
                        values.firmDetails.businessProof = imageSrc
                    }
                } else if (createType === 'seller') {
                    dispatch(setAlert({ title: 'Error', subtitle: 'Please upload your business proof', active: true, type: 'error' }))
                }
                setSubmitDisabled(false);

                const signupRes = await API.post('/auth/registerUser', values);
                if (signupRes.status === 200 && signupRes.data.data.status === "error") {
                    dispatch(setAlert({ title: 'Error', subtitle: signupRes.data.data.message, active: true, type: 'error' }))
                } else if (signupRes.status === 200) {
                    signupForm.resetForm();
                    history.push('/');
                }
            } catch (error) {
                console.error("Signup failed:", error);
            } finally {
                setSubmitDisabled(false);
            }
            console.log(values)
        }
    })

    const getRkidDetails = (values) => {
        try {
            API.post(`/common/rkIdDetails`, { rkId: values }).then((rkRes) => {
                if (rkRes.status === 200) {
                    const details = rkRes.data.data
                    signupForm.setValues({
                        ...signupForm.values,
                        firstName: details?.userName,
                        mobileNumber: details?.mobile
                    })
                }
            })
        } catch (err) {
            console.log(err)
        }
    }


    const getLocation = (value) => {
        if (value.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${value}`).then((pinRes) => {
                if (pinRes.status === 200) {
                    const location = pinRes.data.data;
                    signupForm.setValues({
                        ...signupForm.values,
                        firmDetails: {
                            ...signupForm.values.firmDetails,
                            accountAddress: {
                                ...signupForm.values.firmDetails?.accountAddress,
                                city: location?.city || '',
                                district: location?.district || '',
                                pinCode: location?.pinCode || '',
                                state: location?.state || '',
                            }
                        }
                    });
                    setAddressEdit(true);
                }
            });
        } else if (value.length === 0) {
            signupForm.setValues({
                ...signupForm.values,
                firmDetails: {
                    ...signupForm.values.firmDetails,
                    accountAddress: {
                        city: '',
                        district: '',
                        pinCode: '',
                        state: '',
                    }
                }
            });
            setAddressEdit(false);
        }
    };

    const uploadFile = (event) => {
        const file = event.target.files[0];

        if (!file) {
            console.error("No file selected");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            // Here you get the base64 string from the image
            setImageSrc(reader.result);  // assuming `setImageSrc` updates your state
        };
        reader.readAsDataURL(file); // This must be a valid File/Blob
    };

    useLayoutEffect(() => {
        if (createType) {
            setTimeout(() => {
                signupForm.setValues({ ...signupForm.values, accountType: createType })
            }, 10)
        }
    }, [createType])
    console.log(signupForm.values)
    return (
        <div className="w-full min-h-screen flex items-center flex-row">
            <div className="w-1/2 hidden lg:inline-flex max-h-auto text-black">
                <div className="w-[450px] min-h-screen bg-primeColor/20 px-10 flex flex-col gap-6 justify-center">
                    <img src={logo} alt="logoImg" className="w-28" />
                    <div className="flex flex-col gap-1 -mt-1">
                        <h1 className="font-titleFont text-xl font-medium">
                            {t('Stay sign in for more')}
                        </h1>
                        <p className="text-base">{t('When you sign in, you are with us!')}</p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Get started fast with Royalkavery')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Access all Royalkavery services')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Trusted by online Shoppers')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="flex items-center justify-between mt-10">
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            © Royalkavery
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Terms')}
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Privacy')}
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Security')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="w-full bg-white h-[100vh] overflow-y-scroll grid  grid-cols-1 gap-10 items-center justify-center">
                <motion.div className="flex flex-col  bg-white z-10 cursor-pointer items-center justify-center" onClick={() => history.push('/')}>
                    <img src={logo} height={100} width={100} alt="logo" />
                </motion.div>
                <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2">
                    <FieldSelect label="Choose Account Type" fieldProps={signupForm.getFieldProps('accountType')} fieldHelper={signupForm.getFieldHelpers('accountType')} fieldMeta={signupForm.getFieldMeta('accountType')} edit={true} dataLoaded={true} options={accountTypes} onChange={(e) => setCreateType(e)} />
                    <motion.div className='flex flex-row w-full'>
                        <FieldInput label="If You have RKID" placeholder="RKID" fieldProps={signupForm.getFieldProps('rkId')} fieldHelper={signupForm.getFieldHelpers('rkId')} fieldMeta={signupForm.getFieldMeta('rkId')} edit={signupForm.values.accountType} dataLoaded={true} />
                        <motion.div className="flex flex-row items-center justify-center">
                            <motion.div className="bg-primeColor/20 h-12 w-32 flex flex-row items-center justify-center cursor-pointer text-center rounded-full text-black hover:bg-primeColor hover:text-white" onClick={() => getRkidDetails(signupForm.values.rkId)}>{t('Get Details')}</motion.div>
                        </motion.div>
                    </motion.div>
                    <FieldInput label={t("First Name")} placeholder={t("First Name")} fieldProps={signupForm.getFieldProps('firstName')} fieldHelper={signupForm.getFieldHelpers('firstName')} fieldMeta={signupForm.getFieldMeta('firstName')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label={t("Last Name")} placeholder={t("Last Name")} fieldProps={signupForm.getFieldProps('lastName')} fieldHelper={signupForm.getFieldHelpers('lastName')} fieldMeta={signupForm.getFieldMeta('lastName')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label={t("Email")} placeholder={t("Email")} fieldProps={signupForm.getFieldProps('email')} fieldHelper={signupForm.getFieldHelpers('email')} fieldMeta={signupForm.getFieldMeta('email')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label={t("Mobile Number")} placeholder={t("Mobile Number")} fieldProps={signupForm.getFieldProps('mobileNumber')} fieldHelper={signupForm.getFieldHelpers('mobileNumber')} fieldMeta={signupForm.getFieldMeta('mobileNumber')} edit={signupForm.values.accountType} dataLoaded={true} />
                    {/* <FieldInput label="Address Line 1" placeholder="Address Line 1" fieldProps={signupForm.getFieldProps('address.addressLine1')} fieldHelper={signupForm.getFieldHelpers('address.addressLine1')} fieldMeta={signupForm.getFieldMeta('address.addressLine1')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label="Address Line 2" placeholder="Address Line 2 (Optional)" fieldProps={signupForm.getFieldProps('address.addressLine2')} fieldHelper={signupForm.getFieldHelpers('address.addressLine2')} fieldMeta={signupForm.getFieldMeta('address.addressLine2')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label="City" placeholder="City" fieldProps={signupForm.getFieldProps('address.city')} fieldHelper={signupForm.getFieldHelpers('address.city')} fieldMeta={signupForm.getFieldMeta('address.city')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label="State" placeholder="State" fieldProps={signupForm.getFieldProps('address.state')} fieldHelper={signupForm.getFieldHelpers('address.state')} fieldMeta={signupForm.getFieldMeta('address.state')} edit={signupForm.values.accountType} dataLoaded={true} />
                    <FieldInput label="Pincode" placeholder="Pincode" fieldProps={signupForm.getFieldProps('address.pinCode')} fieldHelper={signupForm.getFieldHelpers('address.pinCode')} fieldMeta={signupForm.getFieldMeta('address.pinCode')} edit={signupForm.values.accountType} dataLoaded={true} /> */}
                    {createType !== 'seller' && <>
                        <FieldInput label={t("Password")} type="password" placeholder={t("Password")} fieldProps={signupForm.getFieldProps('password')} fieldHelper={signupForm.getFieldHelpers('password')} fieldMeta={signupForm.getFieldMeta('password')} edit={signupForm.values.accountType} dataLoaded={true} />
                        <FieldInput label={t("Confirm Password")} type="password" placeholder={t("Confirm Password")} fieldProps={signupForm.getFieldProps('confirmPassword')} fieldHelper={signupForm.getFieldHelpers('confirmPassword')} fieldMeta={signupForm.getFieldMeta('confirmPassword')} edit={signupForm.values.accountType} dataLoaded={true} />
                    </>}
                </motion.div>
                {createType === 'seller' && <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1">
                    <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                        <FieldInput label={'Firm Name'} placeholder={'Firm Name'} fieldProps={signupForm.getFieldProps('firmDetails.accountName')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountName')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountName')} edit={true} dataLoaded={true} />
                        <FieldSelect label={'Firm Registration Type'} placeholder={'Firm Registration Type'} fieldProps={signupForm.getFieldProps('firmDetails.firmRegistrationType')} fieldHelper={signupForm.getFieldHelpers('firmDetails.firmRegistrationType')} fieldMeta={signupForm.getFieldMeta('firmDetails.firmRegistrationType')} edit={true} dataLoaded={true} options={firmTypes} />
                        <FieldInput label={'PAN Card No'} placeholder={'PAN Card no'} fieldProps={signupForm.getFieldProps('firmDetails.panCardNo')} fieldHelper={signupForm.getFieldHelpers('firmDetails.panCardNo')} fieldMeta={signupForm.getFieldMeta('firmDetails.panCardNo')} edit={true} dataLoaded={true} />
                        {/* <FieldInput type="file" label={'Business Proof'} placeholder={'Business Proof'} fieldProps={signupForm.getFieldProps('firmDetails.businessProof')} fieldHelper={signupForm.getFieldHelpers('firmDetails.businessProof')} fieldMeta={signupForm.getFieldMeta('firmDetails.businessProof')} edit={true} dataLoaded={true} onChange={(ev) => uploadFile(ev)} /> */}
                        <motion.div className="flex px-5 flex-col w-full">
                            <label>Business Proof</label>
                            <input className="px-2 py-2 ring-1 my-1 rounded-md ring-[lightGrey]" type="file" onChange={uploadFile} />
                        </motion.div>
                        <FieldInput type="phone" label={'Firm Mobile Number'} placeholder={'Firm MobileNumber'} fieldProps={signupForm.getFieldProps('firmDetails.mobileNumber')} fieldHelper={signupForm.getFieldHelpers('firmDetails.mobileNumber')} fieldMeta={signupForm.getFieldMeta('firmDetails.mobileNumber')} edit={true} dataLoaded={true} />
                        <FieldInput  label={'Firm Email'} placeholder={'Firm Email'} fieldProps={signupForm.getFieldProps('firmDetails.email')} fieldHelper={signupForm.getFieldHelpers('firmDetails.email')} fieldMeta={signupForm.getFieldMeta('firmDetails.email')} edit={true} dataLoaded={true} />
                    </motion.div>
                    <motion.div className='flex w-full my-2  px-5'>
                        <p className='font-bold text-xl'>Bank Details</p>
                        <div></div>
                    </motion.div>
                    <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                        <FieldInput label={'Bank Name'} placeholder={'Bank Name'} fieldProps={signupForm.getFieldProps('firmDetails.bankDetails.bankName')} fieldHelper={signupForm.getFieldHelpers('firmDetails.bankDetails.bankName')} fieldMeta={signupForm.getFieldMeta('firmDetails.bankDetails.bankName')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Account Name'} placeholder={'Account Name'} fieldProps={signupForm.getFieldProps('firmDetails.bankDetails.accountName')} fieldHelper={signupForm.getFieldHelpers('firmDetails.bankDetails.accountName')} fieldMeta={signupForm.getFieldMeta('firmDetails.bankDetails.accountName')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Account No'} placeholder={'Account No'} fieldProps={signupForm.getFieldProps('firmDetails.bankDetails.accountNo')} fieldHelper={signupForm.getFieldHelpers('firmDetails.bankDetails.accountNo')} fieldMeta={signupForm.getFieldMeta('firmDetails.bankDetails.accountNo')} edit={true} dataLoaded={true} />
                        <FieldInput label={'IFSC Code'} placeholder={'IFSC Code'} fieldProps={signupForm.getFieldProps('firmDetails.bankDetails.ifscCode')} fieldHelper={signupForm.getFieldHelpers('firmDetails.bankDetails.ifscCode')} fieldMeta={signupForm.getFieldMeta('firmDetails.bankDetails.ifscCode')} edit={true} dataLoaded={true} />
                        <FieldInput label={'Branch Name'} placeholder={'Branch Name'} fieldProps={signupForm.getFieldProps('firmDetails.bankDetails.branchName')} fieldHelper={signupForm.getFieldHelpers('firmDetails.bankDetails.branchName')} fieldMeta={signupForm.getFieldMeta('firmDetails.bankDetails.branchName')} edit={true} dataLoaded={true} />
                    </motion.div>
                    <motion.div className='flex w-full my-2  px-5'>
                        <p className='font-bold text-xl'>Firm Address</p>
                        <div></div>
                    </motion.div>
                    <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                        <FieldInput label={'Pincode'} placeholder={'Pincode'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.pinCode')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.pinCode')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                        <FieldInput label={'Address Line 1'} placeholder={'Address Line 1'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.addressLine1')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.addressLine1')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.addressLine1')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'Address Line 2'} placeholder={'Address Line 2'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.addressLine2')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.addressLine2')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.addressLine2')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'City'} placeholder={'City'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.city')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.city')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.city')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'District'} placeholder={'District'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.district')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.district')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.district')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'Landmark'} placeholder={'Landmark'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.landMark')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.landMark')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.landMark')} edit={addressEdit} dataLoaded={true} />
                        <FieldInput label={'State'} placeholder={'State'} fieldProps={signupForm.getFieldProps('firmDetails.accountAddress.state')} fieldHelper={signupForm.getFieldHelpers('firmDetails.accountAddress.state')} fieldMeta={signupForm.getFieldMeta('firmDetails.accountAddress.state')} edit={addressEdit} dataLoaded={true} />
                    </motion.div>
                    <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                        <FieldInput label={t("Password")} type="password" placeholder={t("Password")} fieldProps={signupForm.getFieldProps('password')} fieldHelper={signupForm.getFieldHelpers('password')} fieldMeta={signupForm.getFieldMeta('password')} edit={signupForm.values.accountType} dataLoaded={true} />
                        <FieldInput label={t("Confirm Password")} type="password" placeholder={t("Confirm Password")} fieldProps={signupForm.getFieldProps('confirmPassword')} fieldHelper={signupForm.getFieldHelpers('confirmPassword')} fieldMeta={signupForm.getFieldMeta('confirmPassword')} edit={signupForm.values.accountType} dataLoaded={true} />
                    </motion.div>
                </motion.div>}
                <motion.div className="items-center flex flex-col justify-center">
                    <Button injectClass={`bg-primaryColor ring-[black] rounded-xl ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => !submitDisabled && signupForm.submitForm()}>{t('Sign Up')}</Button>
                    <motion.div className='text-md items-center justify-center flex flex-row'>
                        <p>{t('Already have an account?')}</p>&nbsp;<motion.div className='cursor-pointer underline' onClick={() => history.push('/auth/login')}>{t('Login Here')}</motion.div>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    )
}

export default SignUp